// App version for cache busting
// Increment this whenever you want to force all clients to refresh
// Format: YYYYMMDD.buildNumber (e.g., 20260901.1)
export const APP_VERSION = '20260901.1';

// Storage key for tracking deployed version
const VERSION_STORAGE_KEY = 'lily_app_version';

// A escolha de cookies é um registro de consentimento, não cache: limpá-la a
// cada versão fazia o banner reaparecer para todo mundo a cada deploy.
const CHAVES_PRESERVADAS = ['lily_cookie_consent'];

/**
 * Checks if app version has changed and clears localStorage if it has
 * This forces users to re-authenticate and refresh cached data on new deployments
 */
export function checkAndClearCacheIfVersionChanged() {
  const storedVersion = localStorage.getItem(VERSION_STORAGE_KEY);

  if (storedVersion !== APP_VERSION) {
    console.log(
      `App updated: ${storedVersion || 'first-time'} → ${APP_VERSION}. Clearing cache...`,
    );

    const preservados = CHAVES_PRESERVADAS.map((chave) => [
      chave,
      localStorage.getItem(chave),
    ]);

    // Clear all localStorage to force fresh data
    localStorage.clear();

    // Also clear sessionStorage
    sessionStorage.clear();

    preservados.forEach(([chave, valor]) => {
      if (valor !== null) localStorage.setItem(chave, valor);
    });

    // Store new version
    localStorage.setItem(VERSION_STORAGE_KEY, APP_VERSION);

    // Force page reload to fetch latest assets
    // This ensures users see the newest version immediately
    if (storedVersion) {
      // Only reload if this is an update, not first visit
      window.location.reload();
    }
  }
}

/**
 * Get current app version (useful for debugging)
 */
export function getCurrentAppVersion() {
  return APP_VERSION;
}
